<template>
    <div id="home">
        <div class="welcome">
            <div class="header" data-text="2021">
                Millioner
            </div>
            <div class="ph">
                <span>Q</span>iziqarli <span>V</span>iktorina
            </div>
            <div class="play">
                <button @click="game({prop: 'running', val: true})">
                    O'ynash
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    methods: {
        ...mapActions([
            "game"
        ])
    }
}
</script>

<style lang="scss">
@import "@/styles/welcome";
</style>